import React from 'react';

/**
 * The assistant's replies: paragraphs, bulleted and numbered lists, bold and
 * code. Built as React elements, never as HTML, so nothing in a reply (or in
 * the data it quotes) can run in the page.
 */
function inline(text, keyBase) {
  const parts = [];
  const re = /(\*\*[^*]+\*\*|`[^`]+`)/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const token = m[0];
    parts.push(token.startsWith('**')
      ? <strong key={`${keyBase}-${i}`}>{token.slice(2, -2)}</strong>
      : <code key={`${keyBase}-${i}`}>{token.slice(1, -1)}</code>);
    last = m.index + token.length;
    i += 1;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

function blocks(text) {
  const lines = String(text || '').replace(/\r\n/g, '\n').split('\n');
  const out = [];
  let list = null;
  let para = [];
  const flushPara = () => {
    if (para.length) out.push({ type: 'p', text: para.join(' ') });
    para = [];
  };
  const flushList = () => {
    if (list) out.push(list);
    list = null;
  };
  for (const raw of lines) {
    const line = raw.trim();
    const bullet = /^[-*•]\s+(.*)$/.exec(line);
    const numbered = /^\d+[.)]\s+(.*)$/.exec(line);
    if (bullet || numbered) {
      flushPara();
      const type = bullet ? 'ul' : 'ol';
      if (!list || list.type !== type) {
        flushList();
        list = { type, items: [] };
      }
      list.items.push((bullet || numbered)[1]);
    } else if (!line) {
      flushPara();
      flushList();
    } else {
      flushList();
      para.push(line.replace(/^#{1,6}\s+/, ''));
    }
  }
  flushPara();
  flushList();
  return out;
}

const AssistantText = ({ text }) => (
  <div className="assistant-text">
    {blocks(text).map((b, i) => {
      if (b.type === 'p') return <p key={i}>{inline(b.text, i)}</p>;
      const List = b.type;
      return <List key={i}>{b.items.map((item, j) => <li key={j}>{inline(item, `${i}-${j}`)}</li>)}</List>;
    })}
  </div>
);

export default AssistantText;
